/* stylelint-disable a11y/media-prefers-reduced-motion */

import styled, { keyframes } from 'styled-components';

import { token } from '@atlaskit/tokens';

const fadeIn = keyframes({
  // @ts-expect-error -- pending a typing patch for styled-components@3.4
  from: {
    opacity: 0,
  },
  to: {
    opacity: 1,
  },
});

const rotate = keyframes({
  // @ts-expect-error -- pending a typing patch for styled-components@3.4
  from: {
    transform: 'translate(-50%, -50%) rotate(0deg)',
  },
  to: {
    transform: 'translate(-50%, -50%) rotate(360deg)',
  },
});

export const Wrapper = styled.span`
  display: flex;
  align-items: center;
  transition: opacity 1s ease-in;

  &[data-state] > span:first-child {
    margin: 0 5px;
  }
  svg {
    width: 16px;
    height: 16px;
    transform-origin: 50%;
  }
  &[data-state='pending'] {
    color: ${token('color.icon.information')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='failed'] {
    color: ${token('color.icon.danger')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='success'],
  &[data-state='rerun'] {
    color: ${token('color.icon.success')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='paused'] {
    color: ${token('color.icon.subtle')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='halted'] {
    color: ${token('color.icon.warning')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='waiting'] {
    color: ${token('color.icon.warning')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='stopped'] {
    color: ${token('color.icon.subtle')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='redeploy'] {
    color: ${token('color.icon.success')};
    svg {
      overflow: visible;
    }
  }
  &[data-state='failed_redeploy'] {
    color: ${token('color.icon.danger')};
    svg {
      overflow: visible;
    }
  }
  &[data-state='building'] {
    color: ${token('color.icon.information')};

    > span:first-child {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: calc(100% + 3px);
        height: calc(100% + 3px);
        border-radius: 50%;
        border: 1.5px solid transparent;
        border-top-color: currentColor;
        border-right-color: currentColor;
        transform: translate(-50%, -50%);
        animation: ${rotate} 0.8s linear infinite;
        pointer-events: none;
      }
    }
  }
  &[data-state='unknown'] {
    color: ${token('color.icon.subtle')};
    animation: ${fadeIn} 0.25s ease-in;
  }
  &[data-state='complete'] {
    svg {
      width: 16px;
      height: 16px;
    }
  }
  &[data-state='default'] {
    svg {
      width: 14px;
      height: 14px;
      padding: 1px;
    }
  }
`;
